
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
// Entities
import { Company } from "@/entities/index";

@Component
export default class UpdateClient extends Vue {
  @Prop({ default: false }) value!: boolean;
  @Prop({ default: 0 }) myClientId!: number;
  @Prop({ default: () => ({}) }) client!: Company;

  codeLogistic = "";
  disabledRoute = "";
  image = "";
  transportByTempo = "";
  integrateStepZero = false;
  optionPalette = false;

  rulesPicture = [
    (value: any) =>
      !value ||
      value.size < 2000000 ||
      "La taille de l'image doit être inférieure à 2 Mo !",
  ];

  routeList = [
    { text: "Page stock", value: "stock" },
    { text: "Page préparation", value: "preparation" },
  ];

  transport = [
    { text: "Oui", value: "oui" },
    { text: "Non", value: "non" },
  ];

  @Watch("client", { immediate: true, deep: true })
  onClientChanged(newVal: Company) {
    this.codeLogistic = newVal.codeLogistic;
    this.disabledRoute = newVal.disabledRoute;
    this.integrateStepZero = newVal.integrateStepZero;
    this.transportByTempo = newVal.transportByTempo;
    this.optionPalette = newVal.optionPalette;
  }

  // ========== CRUD ========== //

  updateClient(): void {
    this.$emit("update-client", {
      id: this.myClientId,
      image: this.image,
      codeLogistic: this.codeLogistic,
      disabledRoute: this.disabledRoute,
      integrateStepZero: this.integrateStepZero,
      optionPalette: this.optionPalette,
      transportByTempo: this.transportByTempo,
    });
    this.updateClientForm = false;
  }

  // ========== GETTERS & SETTERS ========== //

  get updateClientForm() {
    return this.value;
  }

  set updateClientForm(value: boolean) {
    this.$emit("input", value);
  }

  // ========== OTHER METHODS ========== //

  handleImage(e: any): void {
    const file = e.target.files[0];
    this.createBase64Image(file);
  }

  createBase64Image(file: File): void {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.image = reader.result as string;
    };
  }

  clear(): void {
    const btnClear = document.getElementById("btnClear");
    btnClear?.classList.add("clicked");
    setTimeout(() => {
      btnClear?.classList.remove("clicked");
    }, 500);

    this.codeLogistic = "";
    this.disabledRoute = "";
    this.transportByTempo = "";
    this.integrateStepZero = false;
    this.optionPalette = false;
  }
}
